import { compose, mapProps } from 'recompose'
import CustomModalContent from '../../ui/views/custom-modal-content'
import withAuctionData from './withAuctionData'

const withPresentationProps = mapProps(({ auction }) => ({
  title: 'Ask a question',
  content: auction.info,
  isRichText: true
}))

export const QuestionsEnhancer = compose(withAuctionData, withPresentationProps)

export default QuestionsEnhancer(CustomModalContent)



// WEBPACK FOOTER //
// ./src/services/auction/Questions.js